export default __webpack_public_path__ + "static/media/CeraRoundProBold.12141644.woff2";